import { uuid } from "../utils/uuid";
import {
  DataSet,
  Data,
  PropertySet,
  View,
  Workbook,
  WorkbookVersion,
  ViewConfig,
  WorkbookPersistent,
} from "../core/Workbook";

// /////////////////////////////
// // Workbook manipulation functions

const newPropertySet = (): PropertySet => {
  return {
    descriptors: {},
    keyToName: {},
    nameToKey: {},
  };
};

export const newDataset = (name: string): DataSet => {
  const initialData: Data = {};
  const propertyMap: PropertySet = newPropertySet();
  const datasetId = uuid();
  return {
    data: initialData,
    properties: propertyMap,
    name: name,
    id: datasetId,
  };
};

export const newView = (name: string, initialConfig: ViewConfig): View => {
  const viewId = uuid();

  const initialView: View = {
    config: initialConfig,
    name: name,
    id: viewId,
  };
  return initialView;
};

const emptyWorkbookPersistent = (): WorkbookPersistent => {
  return {
    views: {},
    viewOrder: [],
    datasets: {},
  };
};

export const emptyWorkbook = (): Workbook => {
  return {
    operational: { selectedView: "", nextSheetNumber: 1 },
    data: emptyWorkbookPersistent(),
    name: "Untitled",
    id: "empty",
    version: WorkbookVersion,
  };
};
